/**
 * Error codes and the wire error envelope used by both HTTP responses and the
 * socket 'error' event. FROZEN after WS-0.
 */
/** Stable, machine-readable error codes. */
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["E_VALIDATION"] = "E_VALIDATION";
    ErrorCode["E_UNAUTHORIZED"] = "E_UNAUTHORIZED";
    ErrorCode["E_FORBIDDEN"] = "E_FORBIDDEN";
    ErrorCode["E_NOT_FOUND"] = "E_NOT_FOUND";
    ErrorCode["E_NOT_HOST"] = "E_NOT_HOST";
    ErrorCode["E_ROOM_FULL"] = "E_ROOM_FULL";
    ErrorCode["E_INVALID_HOST_KEY"] = "E_INVALID_HOST_KEY";
    ErrorCode["E_MEDIA_NOT_READY"] = "E_MEDIA_NOT_READY";
    ErrorCode["E_RATE_LIMITED"] = "E_RATE_LIMITED";
    ErrorCode["E_ADMIN_KEY_REQUIRED"] = "E_ADMIN_KEY_REQUIRED";
    ErrorCode["E_TRANSCODE_FAILED"] = "E_TRANSCODE_FAILED";
    ErrorCode["E_INTERNAL"] = "E_INTERNAL";
})(ErrorCode || (ErrorCode = {}));
/** Default HTTP status mapping for each code. */
export const ERROR_STATUS = {
    [ErrorCode.E_VALIDATION]: 400,
    [ErrorCode.E_UNAUTHORIZED]: 401,
    [ErrorCode.E_FORBIDDEN]: 403,
    [ErrorCode.E_NOT_FOUND]: 404,
    [ErrorCode.E_NOT_HOST]: 403,
    [ErrorCode.E_ROOM_FULL]: 409,
    [ErrorCode.E_INVALID_HOST_KEY]: 403,
    [ErrorCode.E_MEDIA_NOT_READY]: 409,
    [ErrorCode.E_RATE_LIMITED]: 429,
    [ErrorCode.E_ADMIN_KEY_REQUIRED]: 403,
    [ErrorCode.E_TRANSCODE_FAILED]: 500,
    [ErrorCode.E_INTERNAL]: 500,
};
/** A thrown application error carrying a stable code and HTTP status. */
export class AppError extends Error {
    code;
    status;
    details;
    requestId;
    constructor(code, message, options) {
        super(message, options?.cause !== undefined ? { cause: options.cause } : undefined);
        this.name = 'AppError';
        this.code = code;
        this.status = options?.status ?? ERROR_STATUS[code];
        if (options?.details !== undefined)
            this.details = options.details;
        if (options?.requestId !== undefined)
            this.requestId = options.requestId;
    }
}
/** Build an ErrorEnvelope from an AppError. */
export function toEnvelope(err) {
    const env = {
        error: { code: err.code, message: err.message },
    };
    if (err.details !== undefined)
        env.error.details = err.details;
    if (err.requestId !== undefined)
        env.error.requestId = err.requestId;
    return env;
}
//# sourceMappingURL=errors.js.map